import { NgModule, ErrorHandler, Optional, SkipSelf } from '@angular/core';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { LoggingInterceptor } from './interceptors/logging.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { AuthService } from './services/auth.service';
import { LoggingApiService } from './services/logging-api.service';
import { LoggingMessageService } from './services/logging-message.service';
import { PendoService } from './services/pendo.service';
import { StorageService } from './services/storage.service';
import { WindowEventsService } from './services/windows-events.service';
import { UIErrorHandler } from './error-handler';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { CoreComponent } from './core.component';
import { BlankPageComponent } from './blank-page/blank-page.component';
import { CoreRoutingModule } from './core-routing.module';
import { SharedModule } from '../shared/shared.module';
import { LoggerModule } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    CoreComponent,
    BlankPageComponent
  ],
  imports: [
    CoreRoutingModule,
    SharedModule,
    LoggerModule.forRoot({
      serverLoggingUrl: environment.LogService,
      level: environment.LogLevel,
      serverLogLevel: environment.ServerLogLevel,
      disableConsoleLogging: environment.DisableConsoleLogging,
    }),
    RouterModule.forRoot([])
  ],
  exports: [
    RouterModule,
    SharedModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    { provide: ErrorHandler, useClass: UIErrorHandler },
    AuthService,
    WindowEventsService,
    LoggingApiService,
    LoggingMessageService,
    PendoService,
    StorageService
  ]
})

export class CoreModule {
    /**
     * Ensure it can only be imported once
     */
    constructor(@Optional() @SkipSelf() core: CoreModule) {
      if (core) {
        throw new Error('You shall not run!');
      }
    }

}
